import { FormControl, FormHelperText, makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import LoginBanner from "../../components/loginBanner";
import MessagePanel from "../../components/messagePanel";
import getProductData from "../../helpers/getProductData";
import { validateEmail, validatePassword } from "../../helpers/validate.helper";
import { authActions } from "../../store/actions/auth.actions";
import { IDRaksStore } from "../../store/store";
import { IParams } from "../../store/types/auth";
import { Produkt } from "../../store/types/organizacje";
import LoginPageStyle from "../../styles/LoginPageStyle";

interface SignupPageProps {
  onSignup: Function;
  onSignupToProduct: Function;
  onSignupInvite: Function;
  onSignupInviteToProduct: Function;
  error: string;
  onClearError: Function;
}

const SignupPage = (props: SignupPageProps) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [repasswordError, setRepasswordError] = useState("");
  const { product, host, redirect, idorganizacji, idzaproszenia } =
    useParams() as IParams;
  const productData = getProductData(product);
  const {
    onClearError,
    onSignup,
    onSignupToProduct,
    onSignupInvite,
    onSignupInviteToProduct,
  } = props;
  const zaproszenie = idorganizacji && idzaproszenia;
  const zaproszenieZProduktu = zaproszenie && host && redirect;
  const signupDoProduktu = product && host && redirect;

  useEffect(() => {
    return () => {
      onClearError();
    };
  }, [onClearError]);

  const loginLink = () => {
    if (zaproszenie) {
      if (zaproszenieZProduktu)
        return `/logininvite/${idorganizacji}/${idzaproszenia}/${host}/${redirect}`;
      return `/logininvite/${idorganizacji}/${idzaproszenia}`;
    } else if (signupDoProduktu)
      return `/loginproxy/${product}/${host}/${redirect}`;
    return `/login`;
  };

  function validate() {
    onClearError();
    let errEmail = !email
      ? "Pole wymagane"
      : !validateEmail(email)
      ? "Niepoprawny format adresu e-mail."
      : "";
    setEmailError(errEmail);
    const errPassword = validatePassword(password);
    const errRePassword = !repassword ? "Pole wymagane" : "";
    setPasswordError(errPassword);
    setRepasswordError(errRePassword);
    if (password && repassword) {
      if (password !== repassword) {
        setRepasswordError("Hasło i powtórzone hasło nie są identyczne.");
        return false;
      }
      return !errEmail && !errPassword && !errRePassword;
    }
    return false;
  }

  function handleSignup(e: React.FormEvent<HTMLElement>) {
    e.preventDefault();
    if (!validate()) return;
    if (signupDoProduktu)
      onSignupToProduct(email, password, productData.type, host, redirect);
    else if (zaproszenieZProduktu)
      onSignupInviteToProduct(
        email,
        password,
        idorganizacji,
        idzaproszenia,
        host,
        redirect
      );
    else if (zaproszenie)
      onSignupInvite(email, password, idorganizacji, idzaproszenia);
    else onSignup(email, password);
  }

  const useStyles = makeStyles({
    input: {
      fontFamily: "text-security-disc",
    },
  });

  const classes = useStyles();

  return (
    <LoginPageStyle>
      <div className="loginContainer">
        <div className="loginContainer__error">
          {props.error && (
            <MessagePanel title="Błąd" mode="error" message={props.error} />
          )}
        </div>

        <div className="loginContainer__main">
          <div className="loginContainer__main__window">
            <h4 className="loginContainer__main__window__header">
              Zarejestruj
            </h4>
            <form onSubmit={handleSignup}>
              <FormControl error={emailError !== ""}>
                <TextField
                  tc-data="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  label="Adres e-mail"
                />
                {emailError && (
                  <FormHelperText id="email-error-text">
                    {emailError}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl
                error={passwordError !== ""}
                className="signUpPassword"
              >
                <TextField
                  tc-data="password"
                  helperText={
                    "Użyj co najmniej 8 znaków, zastosuj małe i duże litery oraz cyfry."
                  }
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  label="Hasło"
                  InputProps={{ classes: { input: classes.input } }}
                />
                {passwordError && (
                  <FormHelperText id="password-error-text">
                    {passwordError}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl error={repasswordError !== ""}>
                <TextField
                  tc-data="repassword"
                  value={repassword}
                  onChange={(e) => setRepassword(e.target.value)}
                  label="Powtórzone hasło"
                  InputProps={{ classes: { input: classes.input } }}
                />
                {repasswordError && (
                  <FormHelperText id="repassword-error-text">
                    {repasswordError}
                  </FormHelperText>
                )}
              </FormControl>
              <div className="loginContainer__main__window_signupbutton">
                <Button type="submit" variant="contained" color="secondary">
                  ZAŁÓŻ KONTO
                </Button>
              </div>
            </form>
          </div>
          <div className="loginContainer__main__additionaloption subtitle2">
            Masz już konto?{" "}
            <Link to={loginLink()} className="link">
              Zaloguj się.
            </Link>
          </div>
          <div className="caption loginContainer__main__privacy">
            Rejestracja konta oznacza akceptację
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://ftp.raks.pl/marketing/download/pdf/faktury.raks.pl/regulamin_serwisu.pdf"
              className="link"
            >
              &nbsp;regulaminu&nbsp;
            </a>
            oraz
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://ftp.raks.pl/marketing/download/pdf/faktury.raks.pl/polityka_prywatnosci.pdf "
              className="link"
            >
              &nbsp;polityki prywatności.&nbsp;
            </a>
          </div>
        </div>
        <div className="medium subtitle1 loginContainer__footer"></div>
      </div>
      <LoginBanner
        appName={productData.appName}
        appDesc={productData.appDesc}
      />
    </LoginPageStyle>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    error: store.auth.error,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onSignup: (email: string, password: string) =>
      dispatch(authActions.signup(email, password)),
    onSignupToProduct: (
      email: string,
      password: string,
      product: Produkt,
      host: string,
      redirect: string
    ) =>
      dispatch(
        authActions.signupToProduct(email, password, product, host, redirect)
      ),
    onSignupInvite: (
      email: string,
      password: string,
      idOrganizacji: string,
      idZaproszenia: string
    ) =>
      dispatch(
        authActions.signupInvite(email, password, idOrganizacji, idZaproszenia)
      ),
    onSignupInviteToProduct: (
      email: string,
      password: string,
      idOrganizacji: string,
      idZaproszenia: string,
      host: string,
      redirect: string
    ) =>
      dispatch(
        authActions.signupInviteToProduct(
          email,
          password,
          idOrganizacji,
          idZaproszenia,
          host,
          redirect
        )
      ),
    onClearError: () => {
      dispatch(authActions.clearError());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignupPage);
